import { useSelector, useDispatch } from "react-redux";
import { openNavSearch, closeNavSearch } from "@actions/nav-search-actions";

export function useNavSearch() {
  return useSelector((state) => state.navSearch.open);
}

export function useOpenNavSearch() {
  const dispatch = useDispatch();

  return () => dispatch(openNavSearch());
}

export function useCloseNavSearch() {
  const dispatch = useDispatch();

  return () => dispatch(closeNavSearch());
}
